import { get } from 'lodash'

import { Colors, joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { macroCacheOptions, permissionPresets, request, services } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)
const cachedGet = Cache.wrapWithCache(async (key, service, id, params) => {
  return await request.get(joinURLPath(service, id), undefined, params?.query)
})

export default {
  name: 'SingleLink',

  props: {
    value: {
      type: [ String, Object ],
      default: () => {
        return undefined
      }
    },

    params: {
      type: Object,
      default: () => {
        return {}
      }
    },

    length: {
      type: Number,
      default: 50
    },

    service: {
      type: String,
      default: services.users
    },

    pathToId: {
      type: String,
      default: 'id'
    },
    pathToTitle: {
      type: String,
      default: 'title'
    },

    verified: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'link',
      validator: value => {
        return !!~[ 'text', 'link', 'button' ].indexOf(value)
      }
    },

    to: {
      type: Object,
      default: undefined
    },

    copy: {
      type: Boolean,
      default: false
    },

    flat: {
      type: Boolean,
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    },
    depressed: {
      type: Boolean,
      default: false
    },

    color: {
      type: String,
      default: Colors.primary
    }
  },

  data() {
    return {
      data: undefined
    }
  },

  computed: {
    title() {
      let result = get(this.data, this.pathToTitle, this.data.username)
      if (result && typeof result === 'string' && result.length > this.length) {
        result = result.slice(0, this.length) + '...'
      }

      return result
    },

    $type() {
      let result = this.type
      if (!this.checkPermissions(`advanced.${this.service}.get`, permissionPresets.managerUp)) {
        result = 'text'
      }

      return result
    },

    $to() {
      if (this.to) {
        return this.to
      }

      return {
        name: `${this.service}.single`,
        params: { id: get(this.data, this.pathToId) }
      }
    }
  },

  watch: {
    value: {
      handler() {
        this.get()
      },
      deep: true
    }
  },

  mounted() {
    this.get()
  },

  methods: {
    async get() {
      if (typeof this.value === 'string') {
        if (this.checkPermissions(`advanced.${this.service}.get`, permissionPresets.resellerUp)) {
          if (this.value) {
            const data = await cachedGet(`${this.service}:${this.value}`, this.service, this.value, this.params)
            if (data) {
              this.data = data
            }
          }
        }
      } else {
        this.data = this.value
      }
    },

    clickHandler() {
      navigator.clipboard.writeText(this.title)
      this.addSnackbar({
        text: this.getTranslate('misc.copied'),
        type: Colors.success
      })
    }
  },

  render
}
